<template>
  <div name="otp-group" ref="otpGroup">
    <slot :focus-next="focusNext" :focus-prev="focusPrev" />
  </div>
</template>

<script>
export default {
  name: 'otp-group',

  methods: {
    focusNext(index) {
      if (this.$refs.otpGroup?.children[index + 1]) {
        this.$refs.otpGroup.children[index + 1]?.focus();
      }
    },

    focusPrev(index) {
      if (0 < index) {
        this.$refs.otpGroup.children[index - 1]?.focus();
      }
    },
  },
}
</script>
